module.exports = __webpack_public_path__ + "img/202.57bc103d.jpg";